import { styled } from '@mui/system';
import { Card, Box, Typography } from '@mui/material';

export const CardRoot = styled(Card)(({ theme }) => ({
    borderRadius: 14,
    overflow: 'hidden',
    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.06)',
}));

export const CardHeader = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    background: 'linear-gradient(180deg, rgba(255,153,0,0.06) 0%, rgba(255,153,0,0.00) 100%)',
}));

export const CardBody = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    backgroundColor: '#ffffff',
}));

export const ActionsRow = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(2),
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
}));

export const FieldLabel = styled(Typography)(({ theme }) => ({
    fontSize: 13,
    fontWeight: 700,
    color: '#2b2b2b',
    marginBottom: theme.spacing(0.5),
}));
